// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:545px){.address-info[data-v-066e7580]{font-size:12px!important}}.address-info__block[data-v-066e7580]{display:flex;flex-direction:column;margin-top:15px;line-height:18px}.address-info__block>div[data-v-066e7580]{word-break:break-all}.address-info__map[data-v-066e7580]{width:100%;max-width:250px;aspect-ratio:200/200;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
